import {
    IonButtons,
    IonContent,
    IonHeader,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import React, {useEffect, useState} from "react";
import createAxiosInstance from "../../services/AxiosInstance";
import {Evening} from "../../model/Evening";
import EveningCard from "../../components/evening/EveningCard";
import './Evenings.css'

const Evenings: React.FC = () => {

    const [evenings, setEvenings] = useState<Evening[]>();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const axios = createAxiosInstance();

    useEffect(() => {
        fetchEvenings(currentPage);
    }, []);

    const fetchEvenings = async (page: number) => {
        try {
            const response = await axios.get(`/evening/presence?limit=10&offset=${(page - 1) * 10}`);
            const newEvenings = response.data;
            setEvenings((prevEvenings: Evening[] | undefined) => {
                return prevEvenings ? [...prevEvenings, ...newEvenings] : newEvenings;
            });

            setCurrentPage((prevPage: number) => prevPage + 1);
        } catch (error) {
            console.log(error);
        }
    };


    const loadMoreEvenings = async (event: CustomEvent<void>) => {
        await fetchEvenings(currentPage);
        await (event.target as HTMLIonInfiniteScrollElement).complete();
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton/>
                    </IonButtons>
                    <IonTitle>Aanwezigheid</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                {evenings !== undefined && evenings.map((value: Evening, key: any) => (
                    <EveningCard evening={value}/>
                ))}
                <IonInfiniteScroll threshold="100px" onIonInfinite={loadMoreEvenings}>
                    <IonInfiniteScrollContent
                        loadingSpinner="bubbles"
                        loadingText="Laden meer aanwezigheden...">
                    </IonInfiniteScrollContent>
                </IonInfiniteScroll>
            </IonContent>
        </IonPage>
    )
};

export default Evenings;
